import styled from "styled-components";

export const ProductDetails = styled.div`
  overflow: hidden;
  padding-bottom: 5px;
  padding-top: 20px;
`;

export const ProductOwnerAge = styled.span`
  white-space: nowrap;
`;
